// @ts-nocheck

import React, { useState, useMemo, useEffect } from "react";

import { supabase } from "./supabaseClient";

// === ICONS ===

const Search = () => (

  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

    <circle cx="11" cy="11" r="8"></circle>

    <path d="m21 21-4.35-4.35"></path>

  </svg>

);

const X = () => (

  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

    <line x1="18" y1="6" x2="6" y2="18"></line>

    <line x1="6" y1="6" x2="18" y2="18"></line>

  </svg>

);

const TrendingUp = () => (

  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>

    <polyline points="17 6 23 6 23 12"></polyline>

  </svg>

);

const TrendingDown = () => (

  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

    <polyline points="23 18 13.5 8.5 8.5 13.5 1 6"></polyline>

    <polyline points="17 18 23 18 23 12"></polyline>

  </svg>

);

const Minus = () => (

  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

    <line x1="5" y1="12" x2="19" y2="12"></line>

  </svg>

);

const BarChart = () => (

  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

    <line x1="12" y1="20" x2="12" y2="10"></line>

    <line x1="18" y1="20" x2="18" y2="4"></line>

    <line x1="6" y1="20" x2="6" y2="16"></line>

  </svg>

);

const Users = () => (

  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>

    <circle cx="9" cy="7" r="4"></circle>

    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>

    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>

  </svg>

);

const Target = () => (

  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

    <circle cx="12" cy="12" r="10"></circle>

    <circle cx="12" cy="12" r="6"></circle>

    <circle cx="12" cy="12" r="2"></circle>

  </svg>

);

const ThumbsUp = () => (

  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

    <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>

  </svg>

);

// === KTC-STYLE MULTIPLIER ===

const calculateAdjustedValue = (assets: any[]) => {

  if (assets.length === 0) return 0;

  const rawTotal = assets.reduce((sum, a) => sum + a.value, 0);

  const multipliers = { 1: 1.0, 2: 0.85, 3: 0.72, 4: 0.61, 5: 0.51, 6: 0.43 };

  const multiplier = multipliers[Math.min(assets.length, 6)] || 0.43;

  return Math.round(rawTotal * multiplier);

};

const TrendIcon = ({ trend }: { trend: string }) => {

  if (trend === "up") return <span style={{ color: "#26a69a" }}><TrendingUp /></span>;

  if (trend === "down") return <span style={{ color: "#ff6b6b" }}><TrendingDown /></span>;

  return <span style={{ color: "#b0bec5" }}><Minus /></span>;

};

// === VOTING MODULE – RANDOM CLOSE-VALUE PAIRS, NO POPUP ===

const VotingModule = ({ players }: { players: any[] }) => {

  const [pair, setPair] = useState<any[]>([]);

  const [loading, setLoading] = useState(true);

  const [voting, setVoting] = useState(false);

  const pickRandomClosePair = () => {

    if (players.length < 2) return;

    setLoading(true);

    const shuffled = [...players].sort(() => 0.5 - Math.random());

    let found = false;

    for (let i = 0; i < shuffled.length && !found; i++) {

      for (let j = i + 1; j < shuffled.length; j++) {

        const diff = Math.abs(shuffled[i].value - shuffled[j].value);

        if (diff <= 250 && shuffled[i].id !== shuffled[j].id) {

          setPair([shuffled[i], shuffled[j]]);

          setLoading(false);

          found = true;

          break;

        }

      }

    }

    if (!found) {

      const idx1 = Math.floor(Math.random() * players.length);

      let idx2 = idx1;

      while (idx2 === idx1) idx2 = Math.floor(Math.random() * players.length);

      setPair([players[idx1], players[idx2]]);

      setLoading(false);

    }

  };

  useEffect(() => {

    if (players.length) pickRandomClosePair();

  }, [players]);

  const handleVote = async (winnerId: bigint, loserId: bigint) => {

    if (voting) return;

    setVoting(true);

    try {

      await supabase.rpc("adjust_player_value", { pid: winnerId, delta: 10 });

      await supabase.rpc("adjust_player_value", { pid: loserId, delta: -10 });

      pickRandomClosePair();

    } catch (err) {

      console.error("Vote failed:", err);

    } finally {

      setVoting(false);

    }

  };

  if (loading || pair.length < 2) return null;

  return (

    <div style={{

      background: "white",

      borderRadius: "24px",

      padding: "28px",

      margin: "0 auto 48px",

      maxWidth: "960px",

      boxShadow: "0 12px 40px rgba(0,0,0,0.07)",

      textAlign: "center",

    }}>

      <h3 style={{

        fontSize: "22px",

        fontWeight: 800,

        color: "#2c3e50",

        marginBottom: "20px",

        letterSpacing: "-0.5px",

      }}>

        Community Vote – Who’s Better?

      </h3>

      <div style={{

        display: "flex",

        justifyContent: "center",

        gap: "40px",

        flexWrap: "wrap",

      }}>

        {pair.map((p) => (

          <button

            key={p.id}

            disabled={voting}

            onClick={() => handleVote(p.id, pair.find(x => x.id !== p.id)?.id || 0n)}

            style={{

              background: "linear-gradient(135deg, #f9f9fb 0%, #eef2f7 100%)",

              border: "2px solid #e2e8f0",

              borderRadius: "18px",

              padding: "20px 24px",

              width: "210px",

              cursor: voting ? "not-allowed" : "pointer",

              transition: "all 0.2s ease",

              opacity: voting ? 0.7 : 1,

            }}

            onMouseEnter={(e) => {

              if (!voting) {

                e.currentTarget.style.transform = "translateY(-6px)";

                e.currentTarget.style.boxShadow = "0 12px 24px rgba(255,138,101,0.15)";

                e.currentTarget.style.borderColor = "#ff8a65";

              }

            }}

            onMouseLeave={(e) => {

              e.currentTarget.style.transform = "translateY(0)";

              e.currentTarget.style.boxShadow = "none";

              e.currentTarget.style.borderColor = "#e2e8f0";

            }}

          >

            <div style={{ fontSize: "19px", fontWeight: 700, marginBottom: "6px" }}>

              {p.name}

            </div>

            <div style={{ fontSize: "14px", color: "#718096", marginBottom: "12px" }}>

              {p.team} • {p.position}

            </div>

            <div style={{

              fontSize: "28px",

              fontWeight: 900,

              color: "#ff8a65",

              marginBottom: "12px",

            }}>

              {p.value}

            </div>

            <div style={{ display: "flex", justifyContent: "center", gap: "6px" }}>

              <ThumbsUp />

              <span style={{ fontSize: "13px", color: "#2b6cb0", fontWeight: 600 }}>

                Vote

              </span>

            </div>

          </button>

        ))}

      </div>

      <p style={{

        marginTop: "20px",

        fontSize: "14px",

        color: "#718096",

        fontWeight: 500,

      }}>

        Click a player to vote. New matchup appears instantly.

      </p>

    </div>

  );

};

// === ASSET CARD ===

const AssetCard = ({ asset, onRemove }: any) => (

  <div style={{

    border: "2px solid",

    borderColor: asset.type === "pick" ? "#ffd54f" : "#f0f0f0",

    backgroundColor: asset.type === "pick" ? "#fffef7" : "white",

    borderRadius: "16px",

    padding: "18px",

    display: "flex",

    alignItems: "center",

    justifyContent: "space-between",

    marginBottom: "14px",

    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",

    cursor: "pointer",

    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",

  }}

  onMouseEnter={(e) => {

    e.currentTarget.style.boxShadow = "0 12px 24px rgba(255, 138, 101, 0.2)";

    e.currentTarget.style.transform = "translateY(-4px)";

    e.currentTarget.style.borderColor = "#ff8a65";

  }}

  onMouseLeave={(e) => {

    e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";

    e.currentTarget.style.transform = "translateY(0)";

    e.currentTarget.style.borderColor = asset.type === "pick" ? "#ffd54f" : "#f0f0f0";

  }}>

    <div style={{ flex: 1 }}>

      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>

        <span style={{ fontWeight: 700, color: "#2c3e50", fontSize: "17px" }}>{asset.name}</span>

        {asset.type === "player" && <TrendIcon trend={asset.trend} />}

      </div>

      <div style={{ display: "flex", gap: "10px", fontSize: "13px", color: "#7f8c8d", fontWeight: 500 }}>

        <span>{asset.team}</span>

        <span>•</span>

        <span>{asset.position}</span>

        {asset.type === "player" && asset.age && (

          <>

            <span>•</span>

            <span>Age {asset.age}</span>

          </>

        )}

      </div>

    </div>

    <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>

      <div style={{ textAlign: "right" }}>

        <div style={{ fontSize: "24px", fontWeight: "800", color: "#ff8a65" }}>{asset.value}</div>

        <div style={{ fontSize: "10px", color: "#b0bec5", textTransform: "uppercase", letterSpacing: "1px", fontWeight: 600 }}>Value</div>

      </div>

      <button

        onClick={onRemove}

        style={{ background: "none", border: "none", color: "#b0bec5", cursor: "pointer", padding: "10px", borderRadius: "10px", transition: "all 0.2s" }}

        onMouseEnter={(e) => { e.currentTarget.style.color = "#ff6b6b"; e.currentTarget.style.backgroundColor = "#ffebee"; }}

        onMouseLeave={(e) => { e.currentTarget.style.color = "#b0bec5"; e.currentTarget.style.backgroundColor = "transparent"; }}

      >

        <X />

      </button>

    </div>

  </div>

);

// === ASSET SEARCH ===

const AssetSearch = ({ assets, onSelect, excludeIds }: any) => {

  const [search, setSearch] = useState("");

  const [isOpen, setIsOpen] = useState(false);

  const [filter, setFilter] = useState("all");

  const filteredAssets = useMemo(() => {

    if (!search) return [];

    let results = assets.filter((a: any) => !excludeIds.includes(a.id));

    if (filter === "players") results = results.filter((a: any) => a.type === "player");

    else if (filter === "picks") results = results.filter((a: any) => a.type === "pick");

    results = results.filter((a: any) =>

      a.name.toLowerCase().includes(search.toLowerCase()) ||

      (a.team && a.team.toLowerCase().includes(search.toLowerCase()))

    );

    return results.slice(0, 10);

  }, [search, assets, excludeIds, filter]);

  const handleSelect = (asset: any) => {

    onSelect(asset);

    setSearch("");

    setIsOpen(false);

  };

  return (

    <div style={{ position: "relative" }}>

      <div style={{ display: "flex", gap: "10px", marginBottom: "16px" }}>

        {["all", "players", "picks"].map((f) => (

          <button key={f} onClick={() => setFilter(f)}

            style={{

              padding: "8px 20px", borderRadius: "12px", fontSize: "13px", border: "none", cursor: "pointer",

              backgroundColor: filter === f ? "#ff8a65" : "#f5f5f5", color: filter === f ? "white" : "#546e7a",

              fontWeight: filter === f ? 700 : 500, transition: "all 0.2s",

              boxShadow: filter === f ? "0 4px 12px rgba(255, 138, 101, 0.3)" : "none",

            }}>

            {f.charAt(0).toUpperCase() + f.slice(1)}

          </button>

        ))}

      </div>

      <div style={{ position: "relative" }}>

        <div style={{ position: "absolute", left: "16px", top: "50%", transform: "translateY(-50%)", color: "#b0bec5" }}>

          <Search />

        </div>

        <input type="text" value={search} onChange={(e) => { setSearch(e.target.value); setIsOpen(true); }} onFocus={() => setIsOpen(true)}

          placeholder="Search players and picks..." style={{

            width: "100%", paddingLeft: "48px", paddingRight: "18px", paddingTop: "16px", paddingBottom: "16px",

            border: "2px solid #f0f0f0", borderRadius: "14px", fontSize: "14px", boxSizing: "border-box",

            transition: "all 0.3s", outline: "none", fontWeight: 500,

          }}

          onFocus={(e) => { e.currentTarget.style.borderColor = "#ff8a65"; e.currentTarget.style.boxShadow = "0 0 0 4px rgba(255, 138, 101, 0.1)"; setIsOpen(true); }}

          onBlur={(e) => { e.currentTarget.style.borderColor = "#f0f0f0"; e.currentTarget.style.boxShadow = "none"; }} />

      </div>

      {isOpen && filteredAssets.length > 0 && (

        <>

          <div style={{ position: "fixed", inset: 0, zIndex: 10 }} onClick={() => setIsOpen(false)} />

          <div style={{

            position: "absolute", zIndex: 20, width: "100%", marginTop: "10px", backgroundColor: "white",

            border: "2px solid #f0f0f0", borderRadius: "16px", boxShadow: "0 20px 40px rgba(0,0,0,0.12)",

            maxHeight: "360px", overflowY: "auto",

          }}>

            {filteredAssets.map((asset: any, index: number) => (

              <button key={asset.id} onClick={() => handleSelect(asset)}

                style={{

                  width: "100%", padding: "16px 20px", textAlign: "left", border: "none",

                  borderBottom: index !== filteredAssets.length - 1 ? "1px solid #f5f5f5" : "none",

                  backgroundColor: asset.type === "pick" ? "#fffef7" : "white", cursor: "pointer",

                  transition: "background-color 0.2s",

                }}

                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#fff5f0")}

                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = asset.type === "pick" ? "#fffef7" : "white")}>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>

                  <div>

                    <div style={{ fontWeight: 700, color: "#2c3e50", marginBottom: "4px", fontSize: "15px" }}>{asset.name}</div>

                    <div style={{ fontSize: "13px", color: "#7f8c8d", fontWeight: 500 }}>{asset.team} • {asset.position}</div>

                  </div>

                  <div style={{ color: "#ff8a65", fontWeight: "bold", fontSize: "18px" }}>{asset.value}</div>

                </div>

              </button>

            ))}

          </div>

        </>

      )}

    </div>

  );

};

// === TRADE SUGGESTIONS – SPLIT INTO PLAYERS (5) & PICKS (3) ===

const TradeSuggestions = ({ allAssets, team1Adjusted, team2Adjusted, team1Assets, team2Assets, onAddToTeam1, onAddToTeam2 }: any) => {

  const gap = team1Adjusted - team2Adjusted;

  const needsTeam1 = gap > 0;

  const targetValue = Math.abs(gap);

  const { playerSuggestions, pickSuggestions } = useMemo(() => {

    const selectedIds = [...team1Assets, ...team2Assets].map((a: any) => a.id);

    const available = allAssets.filter((a: any) => !selectedIds.includes(a.id));

    const players = available

      .filter((a: any) => a.type === "player")

      .map((a: any) => ({ ...a, diff: Math.abs(a.value - targetValue) }))

      .sort((a: any, b: any) => a.diff - b.diff)

      .slice(0, 5);

    const picks = available

      .filter((a: any) => a.type === "pick")

      .map((a: any) => ({ ...a, diff: Math.abs(a.value - targetValue) }))

      .sort((a: any, b: any) => a.diff - b.diff)

      .slice(0, 3);

    const bestPlayer = players[0];

    const bestPick = picks[0];

    return {

      playerSuggestions: players.map((p: any) => ({ ...p, isBest: bestPlayer && p.id === bestPlayer.id })),

      pickSuggestions: picks.map((p: any) => ({ ...p, isBest: bestPick && p.id === bestPick.id })),

    };

  }, [allAssets, targetValue, team1Assets, team2Assets]);

  if (Math.abs(gap) < 50 || (playerSuggestions.length === 0 && pickSuggestions.length === 0)) return null;

  return (

    <div style={{

      backgroundColor: "white",

      borderRadius: "28px",

      boxShadow: "0 20px 60px rgba(0,0,0,0.08)",

      padding: "40px",

      marginTop: "40px",

      border: "1px solid rgba(0,0,0,0.03)",

      maxWidth: "1400px",

      margin: "40px auto 0",

    }}>

      <h3 style={{ fontSize: "28px", fontWeight: 900, color: "#2c3e50", marginBottom: "32px", display: "flex", alignItems: "center", gap: "16px" }}>

        <div style={{ width: "48px", height: "48px", borderRadius: "14px", background: "linear-gradient(135deg, #26a69a 0%, #1e8e82 100%)", display: "flex", alignItems: "center", justifyContent: "center", color: "white" }}>

          <Target />

        </div>

        Trade Suggestions

      </h3>

      <p style={{ color: "#546e7a", marginBottom: "32px", fontSize: "16px" }}>

        {needsTeam1 ? "Team 1" : "Team 2"} needs ~{targetValue} more value.

      </p>

      {/* PLAYERS */}

      {playerSuggestions.length > 0 && (

        <div style={{ marginBottom: "40px" }}>

          <h4 style={{ fontSize: "20px", fontWeight: 800, color: "#2c3e50", marginBottom: "16px" }}>Top 5 Players</h4>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "20px" }}>

            {playerSuggestions.map((s: any) => (

              <div

                key={s.id}

                onClick={() => needsTeam1 ? onAddToTeam1(s) : onAddToTeam2(s)}

                style={{

                  backgroundColor: "white",

                  border: `2px solid ${s.isBest ? "#26a69a" : "#e2e8f0"}`,

                  borderRadius: "18px",

                  padding: "20px",

                  cursor: "pointer",

                  transition: "all 0.2s",

                  position: "relative",

                }}

                onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "idd 12px 24px rgba(38,166,154,0.15)"; }}

                onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}

              >

                {s.isBest && (

                  <div style={{

                    position: "absolute", top: "-12px", left: "50%", transform: "translateX(-50%)",

                    backgroundColor: "#26a69a", color: "white", fontSize: "11px", fontWeight: 700,

                    padding: "4px 12px", borderRadius: "12px", letterSpacing: "0.5px"

                  }}>

                    Best Fit

                  </div>

                )}

                <div style={{ fontWeight: 700, color: "#2c3e50", marginBottom: "6px" }}>{s.name}</div>

                <div style={{ fontSize: "13px", color: "#7f8c8d", marginBottom: "12px" }}>

                  {s.team} • {s.position}

                </div>

                <div style={{ fontSize: "24px", fontWeight: 900, color: "#26a69a" }}>{s.value}</div>

                <div style={{ fontSize: "11px", color: "#b0bec5", marginTop: "4px" }}>

                  Diff: {s.diff}

                </div>

              </div>

            ))}

          </div>

        </div>

      )}

      {/* PICKS */}

      {pickSuggestions.length > 0 && (

        <div>

          <h4 style={{ fontSize: "20px", fontWeight: 800, color: "#2c3e50", marginBottom: "16px" }}>Top 3 Draft Picks</h4>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "20px" }}>

            {pickSuggestions.map((s: any) => (

              <div

                key={s.id}

                onClick={() => needsTeam1 ? onAddToTeam1(s) : onAddToTeam2(s)}

                style={{

                  backgroundColor: "#fffef7",

                  border: `2px solid ${s.isBest ? "#26a69a" : "#ffd54f"}`,

                  borderRadius: "18px",

                  padding: "20px",

                  cursor: "pointer",

                  transition: "all 0.2s",

                  position: "relative",

                }}

                onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 12px 24px rgba(255,213,79,0.2)"; }}

                onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}

              >

                {s.isBest && (

                  <div style={{

                    position: "absolute", top: "-12px", left: "50%", transform: "translateX(-50%)",

                    backgroundColor: "#26a69a", color: "white", fontSize: "11px", fontWeight: 700,

                    padding: "4px 12px", borderRadius: "12px", letterSpacing: "0.5px"

                  }}>

                    Best Fit

                  </div>

                )}

                <div style={{ fontWeight: 700, color: "#2c3e50", marginBottom: "6px" }}>{s.name}</div>

                <div style={{ fontSize: "13px", color: "#7f8c8d", marginBottom: "12px" }}>

                  {s.team} • {s.position}

                </div>

                <div style={{ fontSize: "24px", fontWeight: 900, color: "#26a69a" }}>{s.value}</div>

                <div style={{ fontSize: "11px", color: "#b0bec5", marginTop: "4px" }}>

                  Diff: {s.diff}

                </div>

              </div>

            ))}

          </div>

        </div>

      )}

    </div>

  );

};

// === MAIN APP ===

export default function DynastyTradeCalculator() {

  const [team1Assets, setTeam1Assets] = useState<any[]>([]);

  const [team2Assets, setTeam2Assets] = useState<any[]>([]);

  const [allAssets, setAllAssets] = useState<any[]>([]);

  const [players, setPlayers] = useState<any[]>([]);

  const [loading, setLoading] = useState(true);

  const fetchData = async () => {

    try {

      const { data: playerData } = await supabase.from("players").select("*").order("value", { ascending: false });

      const { data: pickData } = await supabase.from("draft_picks").select("*").order("value", { ascending: false });

      const playersWithType = (playerData || []).map((p: any) => ({ ...p, type: "player" }));

      const picksWithType = (pickData || []).map((p: any) => ({ ...p, type: "pick" }));

      setAllAssets([...playersWithType, ...picksWithType]);

      setPlayers(playerData || []);

      setLoading(false);

    } catch (error) {

      console.error("Error:", error);

      setLoading(false);

    }

  };

  useEffect(() => { fetchData(); }, []);

  const team1Raw = team1Assets.reduce((s, a) => s + a.value, 0);

  const team2Raw = team2Assets.reduce((s, a) => s + a.value, 0);

  const team1Adjusted = calculateAdjustedValue(team1Assets);

  const team2Adjusted = calculateAdjustedValue(team2Assets);

  const difference = Math.abs(team1Adjusted - team2Adjusted);

  const percentDiff = team2Adjusted > 0 ? ((difference / team2Adjusted) * 100).toFixed(1) : 0;

  const allSelectedIds = [...team1Assets, ...team2Assets].map(a => a.id);

  const getTradeVerdict = () => {

    if (!team1Assets.length || !team2Assets.length) return { text: "Add assets to both sides", color: "#7f8c8d", bgColor: "#f5f5f5", borderColor: "#e0e0e0" };

    if (percentDiff < 5) return { text: "Fair Trade", color: "#26a69a", bgColor: "#e0f2f1", borderColor: "#80cbc4" };

    if (percentDiff < 15) return { text: "Slightly Uneven", color: "#ffa726", bgColor: "#fff3e0", borderColor: "#ffcc80" };

    const winner = team1Adjusted > team2Adjusted ? "Team 1" : "Team 2";

    return { text: `Favors ${winner}`, color: "#ff6b6b", bgColor: "#ffebee", borderColor: "#ffcdd2" };

  };

  const verdict = getTradeVerdict();

  if (loading) {

    return (

      <div style={{

        minHeight: "100vh", background: "linear-gradient(135deg, #fff5f0 0%, #ffe8dc 50%, #ffd6c8 100%)",

        display: "flex", alignItems: "center", justifyContent: "center", padding: "16px", boxSizing: "border-box"

      }}>

        <div style={{ fontSize: "26px", fontWeight: "bold", color: "#2c3e50", backgroundColor: "white", padding: "40px 60px", borderRadius: "24px", boxShadow: "0 20px 60px rgba(255, 138, 101, 0.2)" }}>

          Loading...

        </div>

      </div>

    );

  }

  return (

    <div style={{

      minHeight: "100vh", background: "linear-gradient(135deg, #fff5f0 0%, #ffe8dc 50%, #ffd6c8 100%)",

      padding: "32px 16px", boxSizing: "border-box", position: "relative"

    }}>

      <div style={{ position: "absolute", top: "10%", right: "5%", width: "300px", height: "300px", borderRadius: "50%", background: "radial-gradient(circle, rgba(255, 138, 101, 0.15) 0%, transparent 70%)", pointerEvents: "none" }}></div>

      <div style={{ position: "absolute", bottom: "10%", left: "5%", width: "250px", height: "250px", borderRadius: "50%", background: "radial-gradient(circle, rgba(38, 166, 154, 0.15) 0%, transparent 70%)", pointerEvents: "none" }}></div>

      <div style={{ maxWidth: "1400px", margin: "0 auto", position: "relative", zIndex: 1 }}>

        {/* VOTING MODULE */}

        <VotingModule players={players} />

        {/* HEADER */}

        <header style={{ textAlign: "center", marginBottom: "56px", paddingTop: "32px" }}>

          <div style={{ display: "inline-flex", alignItems: "center", gap: "12px", backgroundColor: "white", padding: "10px 28px", borderRadius: "30px", marginBottom: "20px", boxShadow: "0 8px 24px rgba(255, 138, 101, 0.15)" }}>

            <BarChart /><span style={{ color: "#ff8a65", fontSize: "14px", fontWeight: 700, letterSpacing: "1px" }}>TRADE ANALYZER</span>

          </div>

          <h1 style={{ fontSize: "56px", fontWeight: "900", background: "linear-gradient(135deg, #ff8a65 0%, #ff6f4a 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", marginBottom: "16px", letterSpacing: "-2px" }}>

            Dynasty Basketball

          </h1>

          <p style={{ color: "#546e7a", fontSize: "20px", fontWeight: 600 }}>Professional Trade Analysis</p>

        </header>

        {/* TEAM CARDS */}

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(340px, 1fr))", gap: "32px", marginBottom: "40px" }}>

          {[

            { num: 1, assets: team1Assets, setAssets: setTeam1Assets, raw: team1Raw, adjusted: team1Adjusted, gradient: "linear-gradient(135deg, #ff8a65 0%, #ff6f4a 100%)", icon: <Users /> },

            { num: 2, assets: team2Assets, setAssets: setTeam2Assets, raw: team2Raw, adjusted: team2Adjusted, gradient: "linear-gradient(135deg, #26a69a 0%, #1e8e82 100%)", icon: <Users /> }

          ].map(({ num, assets, setAssets, raw, adjusted, gradient, icon }) => (

            <div key={num} style={{

              backgroundColor: "white", borderRadius: "28px", boxShadow: "0 20px 60px rgba(0,0,0,0.08)",

              padding: "36px", border: "1px solid rgba(0,0,0,0.03)", margin: "0 8px", maxWidth: "100%", boxSizing: "border-box"

            }}>

              <div style={{ background: gradient, padding: "20px 28px", borderRadius: "18px", marginBottom: "28px", display: "flex", alignItems: "center", justifyContent: "space-between", boxShadow: "0 8px 24px rgba(0,0,0,0.12)" }}>

                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>

                  <div style={{ color: "white", opacity: 0.9 }}>{icon}</div>

                  <h2 style={{ fontSize: "32px", fontWeight: "900", color: "white", margin: 0 }}>Team {num}</h2>

                </div>

                <div style={{ backgroundColor: "rgba(255,255,255,0.25)", padding: "8px 16px", borderRadius: "12px", fontSize: "15px", fontWeight: 700, color: "white" }}>

                  {assets.length} assets

                </div>

              </div>

              <AssetSearch assets={allAssets} onSelect={(a: any) => setAssets([...assets, a])} excludeIds={allSelectedIds} />

              <div style={{ marginTop: "24px", minHeight: "300px" }}>

                {assets.length === 0 ? (

                  <div style={{ textAlign: "center", padding: "80px 20px", color: "#b0bec5", fontSize: "15px" }}>

                    <div style={{ fontSize: "56px", marginBottom: "16px", opacity: 0.3 }}>Basketball</div>

                    <div>Search and add players or picks</div>

                  </div>

                ) : (

                  assets.map((asset: any) => (

                    <AssetCard key={`t${num}-${asset.id}`} asset={asset} onRemove={() => setAssets(assets.filter((a: any) => a.id !== asset.id))} />

                  ))

                )}

              </div>

              <div style={{ marginTop: "28px", paddingTop: "28px", borderTop: "3px solid #f5f5f5", background: "linear-gradient(to bottom, #fafafa, white)", padding: "24px", borderRadius: "16px", marginLeft: "-36px", marginRight: "-36px", marginBottom: "-36px" }}>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "15px", marginBottom: "14px" }}>

                  <span style={{ color: "#7f8c8d", fontWeight: 600 }}>Raw Value:</span>

                  <span style={{ fontWeight: 800, color: "#2c3e50", fontSize: "18px" }}>{raw}</span>

                </div>

                {assets.length > 1 && (

                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "15px", marginBottom: "14px" }}>

                    <span style={{ color: "#7f8c8d", fontWeight: 600 }}>Multiplier ({assets.length} assets):</span>

                    <span style={{ fontWeight: 800, color: "#2c3e50", fontSize: "18px" }}>{(raw > 0 ? adjusted / raw : 1).toFixed(2)}x</span>

                  </div>

                )}

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: "20px", borderTop: "3px solid #e0e0e0" }}>

                  <span style={{ fontSize: "20px", fontWeight: 800, color: "#2c3e50" }}>Adjusted Value:</span>

                  <span style={{ fontSize: "38px", fontWeight: "900", color: "#ff8a65" }}>{adjusted}</span>

                </div>

              </div>

            </div>

          ))}

        </div>

        {/* TRADE ANALYSIS */}

        <div style={{

          backgroundColor: "white", borderRadius: "28px", boxShadow: "0 20px 60px rgba(0,0,0,0.08)",

          padding: "40px", marginBottom: "40px", border: "1px solid rgba(0,0,0,0.03)", maxWidth: "1400px", margin: "0 auto"

        }}>

          <h3 style={{ fontSize: "28px", fontWeight: "900", color: "#2c3e50", marginBottom: "32px", display: "flex", alignItems: "center", gap: "16px" }}>

            <div style={{ width: "48px", height: "48px", borderRadius: "14px", background: "linear-gradient(135deg, #ff8a65 0%, #ff6f4a 100%)", display: "flex", alignItems: "center", justifyContent: "center", color: "white" }}>

              <BarChart />

            </div>

            Trade Analysis

          </h3>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "24px" }}>

            {[

              { label: "Value Difference", value: difference, color: "#2c3e50", bg: "linear-gradient(135deg, #f5f5f5 0%, white 100%)", borderColor: "#e0e0e0" },

              { label: "Percent Difference", value: `${percentDiff}%`, color: "#2c3e50", bg: "linear-gradient(135deg, #f5f5f5 0%, white 100%)", borderColor: "#e0e0e0" },

              { label: "Trade Verdict", value: verdict.text, color: verdict.color, bg: `linear-gradient(135deg, ${verdict.bgColor} 0%, white 100%)`, borderColor: verdict.borderColor }

            ].map((item, i) => (

              <div key={i} style={{ textAlign: "center", padding: "28px", background: item.bg, borderRadius: "20px", border: `3px solid ${item.borderColor}`, boxShadow: "0 8px 20px rgba(0,0,0,0.05)" }}>

                <div style={{ fontSize: "12px", color: "#7f8c8d", marginBottom: "10px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "1.5px" }}>{item.label}</div>

                <div style={{ fontSize: "38px", fontWeight: "900", color: item.color }}>{item.value}</div>

              </div>

            ))}

          </div>

        </div>

        {/* TRADE SUGGESTIONS – SPLIT */}

        <TradeSuggestions

          allAssets={allAssets}

          team1Adjusted={team1Adjusted}

          team2Adjusted={team2Adjusted}

          team1Assets={team1Assets}

          team2Assets={team2Assets}

          onAddToTeam1={(a: any) => setTeam1Assets([...team1Assets, a])}

          onAddToTeam2={(a: any) => setTeam2Assets([...team2Assets, a])}

        />

      </div>

    </div>

  );

}
